<template>
  <tab-header :title="title">
    <div class="container">
      <div
        :class="{ item: true, 'active-item': item.routerName === active }"
        v-for="item of tabList"
        :key="item.routerName"
        @click="handleClickItem(item)"
      >
        {{ item.text }}
      </div>
    </div>
  </tab-header>
</template>

<script>
import TabHeader from './tab-header.vue';
export default {
  name: 'Tabs',
  components: {
    TabHeader,
  },
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    title: String,
  },
  computed: {
    active() {
      return this.$route.name;
    },
  },
  methods: {
    handleClickItem(item) {
      this.$router.push({ name: item.routerName });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.container {
  .box_row();
  .item {
    cursor: pointer;
    font-size: @base-font-size;
    height: 31px;
    margin-right: 40px;
    position: relative;
    .flex_layout(column, space-between);
    &:hover {
      color: @primary-blue;
    }
  }
  .active-item {
    color: @primary-blue;
    font-weight: 700;
    &::after {
      content: '';
      width: 80%;
      height: 2px;
      background: @primary-blue;
    }
  }
}
</style>
